import React from "react"

const withContext = (Context, Component) => {
  return props => {
    return (
      <Context.Consumer>
        {contextProps => <Component {...props} contextProps={contextProps} />}
      </Context.Consumer>
    )
  }
}

export default withContext
